/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';
import * as Enter from 'app/utils/animations/enter';
import * as Leave from 'app/utils/animations/leave';
import ChallengesFilterBarContent from './ChallengesFilterBarContent';
import ChallengesFilterBarHead from './ChallengesFilterBarHead';

type Props = {
  activeCategory: string,
  activeFilter?: string,
  categories: Array<Object>,
  complexity?: Array<string>,
  displayComplexityFilter?: boolean,
  displayEntrantsFilter?: boolean,
  displayFeeFilter?: boolean,
  displayPayoutFilter?: boolean,
  displaySizeFilter?: boolean,
  entrantsOptions?: Array<?number>,
  feeOptions?: Array<number>,
  groupByDate?: boolean,
  isFiltered?: boolean,
  lineUpSizes?: Array<Object>,
  maxEntrants?: number,
  maxFee?: number,
  minEntrants?: number,
  minFee?: number,
  onCategoryChange: (?string) => void,
  onComplexityChange: (?string) => void,
  onGroupByDateChange: boolean => void,
  onLineUpSizeChange: (?number) => void,
  onMaxEntrantsChange: (?number) => void,
  onMaxFeeChange: (?number) => void,
  onMinEntrantsChange: (?number) => void,
  onMinFeeChange: (?number) => void,
  onPayoutChange: (?string) => void,
  onReset: () => void,
  payouts?: Array<Object>
};

type State = {
  isOpen: boolean
};

const FilterBar = glamorous.div(({ theme }) => ({
  alignItems: 'stretch',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  fontSize: theme.fontSize.small,
  justifyContent: 'space-between',
  overflow: 'hidden',
  [theme.mediaQuery.desktopAndUp]: {
    borderTopLeftRadius: theme.borderRadius.default,
    borderTopRightRadius: theme.borderRadius.default,
    marginTop: 10,
    fontSize: '0.83rem'
  }
}));

class ChallengesFilterBar extends React.Component<Props, State> {
  props: Props;

  state: State = {
    isOpen: false
  };

  static defaultProps = {
    activeFilter: undefined,
    complexity: [],
    displayComplexityFilter: false,
    displayEntrantsFilter: false,
    displayFeeFilter: false,
    displayPayoutFilter: false,
    displaySizeFilter: false,
    entrantsOptions: [],
    feeOptions: [],
    groupByDate: false,
    isFiltered: false,
    lineUpSizes: [],
    maxEntrants: undefined,
    maxFee: undefined,
    minEntrants: undefined,
    minFee: undefined,
    payouts: []
  };

  toggleActive = () => {
    this.setState(state => ({
      isOpen: !state.isOpen
    }));
  };

  render() {
    const {
      activeCategory,
      activeFilter,
      categories,
      complexity,
      displayComplexityFilter,
      displayEntrantsFilter,
      displayFeeFilter,
      displayPayoutFilter,
      displaySizeFilter,
      entrantsOptions,
      feeOptions,
      groupByDate,
      isFiltered,
      lineUpSizes,
      maxEntrants,
      maxFee,
      minEntrants,
      minFee,
      onCategoryChange,
      onComplexityChange,
      onGroupByDateChange,
      onLineUpSizeChange,
      onMaxEntrantsChange,
      onMaxFeeChange,
      onMinEntrantsChange,
      onMinFeeChange,
      onPayoutChange,
      onReset,
      payouts
    } = this.props;
    const { isOpen } = this.state;
    const displayFilters =
      displayComplexityFilter ||
      displayEntrantsFilter ||
      displayFeeFilter ||
      displayPayoutFilter ||
      displaySizeFilter;

    return (
      <FilterBar>
        <ChallengesFilterBarHead
          activeCategory={activeCategory}
          activeFilter={activeFilter}
          categories={categories}
          isActive={isOpen}
          isFiltered={isFiltered}
          onCategoryChange={onCategoryChange}
          onClick={displayFilters ? this.toggleActive : undefined}
          onReset={onReset}
        />
        {displayFilters && (
          <AnimatedGroup onEnter={Enter.grow(0.3)} onLeave={Leave.shrink(0.3)}>
            {isOpen && (
              <ChallengesFilterBarContent
                activeCategory={activeCategory}
                complexity={complexity}
                displayComplexityFilter={displayComplexityFilter}
                displayEntrantsFilter={displayEntrantsFilter}
                displayFeeFilter={displayFeeFilter}
                displayPayoutFilter={displayPayoutFilter}
                displaySizeFilter={displaySizeFilter}
                entrantsOptions={entrantsOptions}
                feeOptions={feeOptions}
                groupByDate={groupByDate}
                lineUpSizes={lineUpSizes}
                maxEntrants={maxEntrants}
                maxFee={maxFee}
                minEntrants={minEntrants}
                minFee={minFee}
                onComplexityChange={onComplexityChange}
                onGroupByDateChange={onGroupByDateChange}
                onLineUpSizeChange={onLineUpSizeChange}
                onMaxEntrantsChange={onMaxEntrantsChange}
                onMaxFeeChange={onMaxFeeChange}
                onMinEntrantsChange={onMinEntrantsChange}
                onMinFeeChange={onMinFeeChange}
                onPayoutChange={onPayoutChange}
                onReset={onReset}
                payouts={payouts}
              />
            )}
          </AnimatedGroup>
        )}
      </FilterBar>
    );
  }
}

export default ChallengesFilterBar;
